<template>
    <div >
     <page-header></page-header>
     <router-view></router-view>
     <page-footer></page-footer>
    </div>
  </template>
  
  <script>
  import PageHeader from '../../components/PageHeader'
  import PageFooter from '../../components/pageFooter'
  
  export default {
    name: 'App',
    components: {
      PageHeader,PageFooter
    }
  }
  </script>
  
  <style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    
  }
  body{
    padding: 0; margin: 0;
  }
  </style>
  